'use strict';

const allVideos = [
	...require('./robloxVideos'),
	...require('./minecraftVideos'),
	{
		name: 'KIDS_PROMO',
		url: '169683169'
	},
	{
		name: 'PARENTS_PROMO',
		url: '169676431'
	},
	{
		name: 'MEET_THE_TEAM',
		url: '162050079'
	},
	{
		name: 'CODING_IS_HARD',
		url: 'zUolVihbNWo'
	},
	{
		name: 'EDUCATORS_PROMO',
		url: '175406141'
	},
	{
		name: 'WHAT_NEXT',
		url: 'tXdSdIPVgN4'
	},
	{
		name: 'SERVER_TROUBLESHOOTING',
		url: 'r0UEtYBHP_c'
	},
	{
		name: 'SERVER_ONBOARDING',
		url: 'nanztNZQnnA'
	},
	{
		name: 'POCKET_SERVER_TROUBLESHOOTING',
		url: 'ww1iEThOZyQ'
	},
	{
		name: 'POCKET_WELCOME_TO_SEQUENCER',
		url: '_9meq8LAI38'
	},
	{
		name: 'POCKET_SERVER_ONBOARDING',
		url: 'ztFU15uXss0'
	},
	{
		name: 'WHICH_EDITION',
		url: '4xKVdwrh3co'
	},
	{
		name: 'COURSE_EXTENSIONS',
		url: 'ziperl-JyqY'
	},
	{
		name: 'TYCERX_1',
		url: 'bpWs5SGLV5E'
	},
	{
		name: 'JEROMEASF_1',
		url: 'VLyOYMEJwXw'
	},
	{
		name: 'CARD_AUTH_EXPLAIN',
		url: 'P5CsEB-fOVs'
	},
	{
		name: 'UPGRADE_PREMIUM',
		url: 'f-g07sA8RTI'
	},
	{
		name: 'HOW_TO_USE_SUPPORT',
		url: 'D51uUeUza24'
	},
	{
		name: 'WHY_COMPUTING',
		url: 'nKIu9yen5nc'
	},
	{
		name: 'FAQ_UNBAN_PLAYERS',
		url: 'yn2_dMJaFi8'
	}
];

module.exports = require('../data/createCollection')(require('../schemas/VideoSchema'), allVideos);
